import type { DashboardDateRange } from "../dashboard";
import { bar, countBy, inRange, stat, type AreaSummary } from "./build";

export type TransactionsInput = {
  transactions: ReadonlyArray<{ transactionType: string; transactionDate: Date | string }>;
};

export function summarizeTransactions({ transactions }: TransactionsInput, range: DashboardDateRange): AreaSummary {
  const inPeriod = transactions.filter((transaction) => inRange(transaction.transactionDate, range));
  return {
    movementCount: stat(inPeriod.length),
    movementsByType: bar(countBy(inPeriod, (transaction) => transaction.transactionType)),
  };
}
